"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WithdrawChipsAction = void 0;
class WithdrawChipsAction {
    execute(playerManager, blackjackState, instant) {
        blackjackState.withdrawChips(playerManager.currentPlayer.currentBet, instant);
    }
}
exports.WithdrawChipsAction = WithdrawChipsAction;
